module.exports = __webpack_public_path__ + "static/media/Money.ed238212.svg";